import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { column, report, saveReportModel, reportCategory } from 'src/app/dashboards/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { I18NextPipe } from "angular-i18next";
import { gridItem } from "src/app/models";
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import * as mainActions from 'src/app/state/app.actions'
import * as _ from "lodash";

@Component({
    selector: 'app-reports-dialog-save-as-edit',
    templateUrl: 'reports-dialog-save-as-edit.component.html',
    styleUrls: ['./reports-dialog-save-as-edit.component.scss'],
    standalone: false
})

export class ReportsDialogSaveAsEditComponent implements OnInit {

  reportCategories: Array<reportCategory>;

  get title(): string {
    return this.data.type === DialogSaveAsEditTypes.SaveAs ? "Save as" : "Edit";
  }

  constructor(
    private DashboardsService: DashboardService,
    private store: Store<State>,
    private i18nextPipe: I18NextPipe,
    public dialogRef: MatDialogRef<ReportsDialogSaveAsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSaveAsEditData) { }

  ngOnInit(): void {
    let myString = this.i18nextPipe.transform('dashboard:My') + " ";
    this.DashboardsService.getReportCategories().subscribe(reportCategories =>{
      this.reportCategories = reportCategories;
      if(!this.reportCategories.find(c => c.id === this.data.report.categoryId)) {
        this.data.report.categoryId = null;
      }
    });

    if (!this.data.report.shortDescription.startsWith(myString) && this.data.type == DialogSaveAsEditTypes.SaveAs) {
      this.data.report.shortDescription = myString + this.data.report.shortDescription;
    }
  }

  onSaveClick(): void {
    if (this.data.gridItem?.setup) {
      this.data.gridItem.setup.reportType = this.data.gridItem.type;
    }
    let setup = _.cloneDeep(this.data.gridItem?.setup);

    if (this.data.gridItem?.setup["G"]) {
      setup["G"] = setup["G"].filter(g => g.toString().indexOf("_") < 0).map(g => Number(g));
    }


    const saveReportModel: saveReportModel = {
      setup: setup,
      id: this.data.report.id,
      shortDescription: this.data.report.shortDescription,
      // just to signal to the back-end it is "Save as" functionality, not "Edit" or "Save"
      subReportId: this.data.type == DialogSaveAsEditTypes.SaveAs ? 0 : this.data.report.subReportId,
      userDescription: this.data.report.userDescription === undefined ? "" : this.data.report.userDescription,
      // Because the type of categoryId is nullable number, not a string or undefined
      categoryId: !this.data.report.categoryId || this.data.report.categoryId.toString() === "" ? null : this.data.report.categoryId
    };

    this.DashboardsService.SaveReport(saveReportModel).subscribe(
      (d) => {
        if (d == 0) {
          this.store.dispatch(mainActions.addMessage({ message: new InfoMessage(this.i18nextPipe.transform('messages:Report Saved!'), "") }));
          this.dialogRef.close(true);
        } else if (d == -2) {
          this.store.dispatch(mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform("messages:Couldn't save report!"),
              this.i18nextPipe.transform('messages:Name is in use.'))
          }));
        } else {
          this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
        }
      },
      (error) => {
        this.store.dispatch(mainActions.addMessage({ message: new ErrorMessage(this.i18nextPipe.transform("messages:Couldn't save report!"), "") }));
      }
    );
  }
}

export enum DialogSaveAsEditTypes {
  SaveAs,
  Edit
}

export class DialogSaveAsEditData {
  report: report;
  type: DialogSaveAsEditTypes;
  gridItem: gridItem

  constructor(report, type: DialogSaveAsEditTypes, gridItem) {
    this.report = report;
    this.type = type;
    this.gridItem = gridItem;
  }
}
